import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Text } from 'rebass/styled-components';
import { CircleCheckBig } from 'lucide-react';

export const SuccessMessage = ({ title, description }) => (
  <Flex sx={{ flexDirection: 'column', gap: '24px', alignItems: 'flex-start' }}>
    <Box as={CircleCheckBig} size={48} sx={{ color: 'icon.success' }} />
    <Flex sx={{ flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
      <Text
        sx={{
          fontSize: '16px',
          fontWeight: '600',
          color: 'text.dark',
          lineHeight: '1.4',
        }}
      >
        {title}
      </Text>
      <Text
        sx={{
          fontSize: '14px',
          lineHeight: '1.4',
        }}
      >
        {description}
      </Text>
    </Flex>
  </Flex>
);

SuccessMessage.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

SuccessMessage.defaultProps = {
  title: 'Thanks for joining!',
  description: "We'll get in touch when there are relevant opportunities.",
};
